import { Component, inject } from '@angular/core';
import { OtherUsePerRegisterService } from '../proxy/planning/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  OtherUsePerRegisterCreateDto,
  OtherUsePerRegisterDto,
  OtherUsePerRegisterExcelDownloadDto,
  OtherUsePerRegisterUpdateDto,
} from '../proxy/planning/dtos/other-use-per-register';
import { OTHERUSEPERREGISTER_CONFIG, OTHERUSEPERREGISTER_FIELDS } from './other-use-per-register.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-other-use-per-register',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, OtherUsePerRegisterService, ConfirmationService],
  templateUrl: './other-use-per-register.html',
  styleUrl: './other-use-per-register.scss',
})
export class OtherUsePerRegister extends BaseCrudComponent<
  OtherUsePerRegisterDto,
  OtherUsePerRegisterCreateDto,
  OtherUsePerRegisterUpdateDto,
  OtherUsePerRegisterExcelDownloadDto
> {
  service = inject(OtherUsePerRegisterService);
  config = OTHERUSEPERREGISTER_CONFIG;
  fields = OTHERUSEPERREGISTER_FIELDS;

  protected prepareUpdateDto(data: any, selected: OtherUsePerRegisterDto): OtherUsePerRegisterUpdateDto {
    return {
      otherUseId: data.otherUseId,
      registerId: data.registerId,
      gisOtherUseRegisterArea: data.gisOtherUseRegisterArea,
      registerAreaCorrection: data.registerAreaCorrection,
      otherUseRegisterArea: data.otherUseRegisterArea,
      otherUseAreaPercentage: data.otherUseAreaPercentage,
      isMainRegister: data.isMainRegister,
      isLastRegister: data.isLastRegister,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'OtherUsePerRegister';
  }
}
